import React from "react";
import { PayInfoDetailProps } from "../PayInfoDetail";
import { PayDetailItem, PayDetailItemText } from "./PartyFeePay";
import bankSetData from "../../../../../datafiles/bank_set.json";
import { GetStringByKey } from "../../../../../Api/ApiTranslate";

export default function MoneyWithdraw({ data }: PayInfoDetailProps) {
  const getBankData = (bankCode: string) => {
    const bankData = bankSetData.find((b) => b.bankCode === bankCode);
    return bankData;
  };

  return (
    <>
      {/* label */}
      <PayDetailItem>
        <PayDetailItemText>
          [
          {GetStringByKey(getBankData(data?.log?.bankname)?.bankName) ??
            data?.log?.bankname}
          ] {data?.log?.banknum}
        </PayDetailItemText>
      </PayDetailItem>

      {/* value */}
      <PayDetailItem>
        {/* 잔여 파티 요금 환급 */}
        <PayDetailItemText>(예금주: {data?.name})</PayDetailItemText>
      </PayDetailItem>
    </>
  );
}
